import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PuneetShareClass from "../components/PuneetShareClass";

const PuneetShareClassPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Puneet Share-class' />

        {/* BlankPageLayer */}
        <PuneetShareClass />
      </MasterLayout>
    </>
  );
};

export default PuneetShareClassPage;
